"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[681],{

/***/ 2655:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


window.PSTheme.Vue.OurBeliefs = new (vue__WEBPACK_IMPORTED_MODULE_0___default())({
  name: 'OurBeliefs',

  data() {
    return {
      expandDescription1: false,
      expandDescription2: false,
      expandDescription3: false
    };
  }

}).$mount('.our-beliefs');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346], function() { return __webpack_exec__(2655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);